import { createSelector } from 'reselect';

import { IconFloor } from 'shared/components/UI/Icons/IconFloor';
import { IconTable } from 'shared/components/UI/Icons/IconTable';
import { IconTime } from 'shared/components/UI/Icons/IconTime';
import {
  getCoworkingAccessLabel,
  getCoworkingFloorLabel,
  getCoworkingWorkplaceCountLabel,
} from 'shared/utils/formatters';

import { coworkingSelector } from '../root/coworkingSelector';

export const getCoworkingSpecificationsSelector = createSelector(coworkingSelector, coworking => {
  if (!coworking) {
    return [];
  }

  const { floorFrom, floorTo, workplaceCount, worktime } = coworking;

  return [
    {
      key: 'coworkingFloor',
      title: 'Этаж',
      text: getCoworkingFloorLabel(floorFrom, floorTo),
      icon: IconFloor,
    },
    {
      key: 'coworkingCapacity',
      title: 'Вместимость',
      text: getCoworkingWorkplaceCountLabel(workplaceCount),
      icon: IconTable,
    },
    {
      key: 'coworkingAccess',
      title: 'Время работы',
      text: getCoworkingAccessLabel(worktime),
      icon: IconTime,
    },
  ];
});
